import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '@ooh/ui/components/button';
import { decodeCatalogSearch } from '../../../lib/catalog-return-context';

export function MediaUnitNotFoundError({ catalogSearch }: { catalogSearch?: string }) {
  const { t } = useTranslation('common');
  return (
    <div
      data-testid="not-found-error"
      className="flex flex-col items-center justify-center h-screen gap-4"
    >
      <p>{t('errors.notFound')}</p>
      <Button variant="outline" asChild>
        <Link to="/media-units" search={decodeCatalogSearch(catalogSearch)}>
          {t('errors.backToCatalog')}
        </Link>
      </Button>
    </div>
  );
}
